import firebase from "firebase";
import { OlabUtils } from "./olabutils.js";

class OlabPackage {
  constructor(pkg) {
    if (pkg == null) {
      this.initPackage();
    } else {
      let hp = Object.prototype.hasOwnProperty;
      this.editDisplayState = hp.call(pkg, "editDisplayState")
        ? pkg.editDisplayState
        : "inline";
      this.olab_id = hp.call(pkg, "olab_id") ? pkg.olab_id : null;
      this.olab_type = hp.call(pkg, "olab_type") ? pkg.olab_type : null;
      this.name = hp.call(pkg, "name") ? pkg.name : null;
      this.name_uc = hp.call(pkg, "name_uc") ? pkg.name_uc : null;
      this.creator = hp.call(pkg, "creator") ? pkg.creator : null;
      this.creator_uc = hp.call(pkg, "creator_uc") ? pkg.creator_uc : null;
      this.desc = hp.call(pkg, "desc") ? pkg.desc : null;
      this.package_seq_type = hp.call(pkg, "package_seq_type")
        ? pkg.package_seq_type
        : "library_sequence";
      this.package_type = hp.call(pkg, "package_type")
        ? pkg.package_type
        : null;
      this.library_id =
        this.package_type != null
          ? OlabPackage.pkgTypeToLibraryID(pkg.package_type)
          : null;
      this.comps = hp.call(pkg, "comps") ? pkg.comps : [];
    }
  }

  static getOlabPackageConverter() {
    // Firestore data converter
    let olabPackageConverter = {
      toFirestore: function(pkg) {
        return {
          editDisplayState: pkg.editDisplayState,
          olab_id: pkg.olab_id,
          olab_type: pkg.olab_type,
          name: pkg.name,
          name_uc: pkg.name_uc,
          creator: pkg.creator,
          creator_uc: pkg.creator_uc,
          desc: pkg.desc,
          package_seq_type: pkg.package_seq_type,
          package_type: pkg.package_type,
          library_id: OlabPackage.pkgTypeToLibraryID(pkg.package_type),
          comps: pkg.comps
        };
      },
      fromFirestore: function(snapshot, options) {
        const data = snapshot.data(options);
        return new OlabPackage(data);
      }
    };
    return olabPackageConverter;
  }

  static getCreatePackageConverter() {
    // Firestore data converter
    let olabPackageConverter = {
      toFirestore: function(pkg) {
        return {
          editDisplayState: pkg.editDisplayState,
          olab_id: pkg.olab_id,
          olab_type: pkg.olab_type,
          name: pkg.name,
          name_uc: pkg.name_uc,
          creator: pkg.creator,
          creator_uc: pkg.creator_uc,
          desc: pkg.desc,
          package_seq_type: pkg.package_seq_type,
          package_type: pkg.package_type,
          library_id: OlabPackage.pkgTypeToLibraryID(pkg.package_type),
          comps: pkg.comps,
          created_date: firebase.firestore.FieldValue.serverTimestamp()
        };
      },
      fromFirestore: function(snapshot, options) {
        const data = snapshot.data(options);
        return new OlabPackage(data);
      }
    };
    return olabPackageConverter;
  }

  static getUpdatePackageConverter() {
    // Firestore data converter
    let olabPackageConverter = {
      toFirestore: function(pkg) {
        return {
          editDisplayState: pkg.editDisplayState,
          // olab_id: pkg.olab_id,
          // olab_type: pkg.olab_type,
          name: pkg.name,
          name_uc: pkg.name_uc,
          creator: pkg.creator,
          creator_uc: pkg.creator_uc,
          desc: pkg.desc,
          package_seq_type: pkg.package_seq_type,
          package_type: pkg.package_type,
          library_id: OlabPackage.pkgTypeToLibraryID(pkg.package_type),
          comps: pkg.comps,
          updated_date: firebase.firestore.FieldValue.serverTimestamp()
        };
      },
      fromFirestore: function(snapshot, options) {
        const data = snapshot.data(options);
        return new OlabPackage(data);
      }
    };
    return olabPackageConverter;
  }

  static pkgTypeToLibraryID(pkgType) {
    let libraryID = "unknown";
    switch (pkgType) {
      case "gene":
        libraryID = "LG";
        break;
      case "promoter":
        libraryID = "LP";
        break;
      case "rbs":
        libraryID = "LR";
        break;
      case "terminator":
        libraryID = "LT";
        break;
      default:
        libraryID = "unknown";
        break;
    }
    return libraryID;
  }

  initPackage() {
    OlabUtils.infoLog("OlabPackage.initPackage() ...");
    // Common fields: internal use
    this.olab_id = null;
    this.olab_type = null;
    this.name_uc = null;
    this.creator_uc = null;
    this.library_id = null;

    // Common fields: User settable
    this.name = null;
    this.creator = null;
    this.desc = null;
    this.package_seq_type = "library_sequence";
    this.package_type = null;
    this.comps = [];
  }

  set(pkg) {
    this.olab_id = pkg.olab_id;
    this.olab_type = pkg.olab_type;
    this.name = pkg.name;
    // append unique key to name_uc for search to work later
    if (this.name != null) {
      this.name_uc = this.name.toUpperCase() + " ^%#- " + this.olab_id;
    } else {
      this.name_uc = null;
    }
    this.creator = pkg.creator;
    // append unique key to creator_uc for search to work later
    if (this.creator != null) {
      this.creator_uc = this.creator.toUpperCase() + " ^%#- " + this.olab_id;
    } else {
      this.creator_uc = null;
    }
    this.desc = pkg.desc;
    this.package_seq_type = pkg.package_seq_type;
    this.package_type = pkg.package_type;
    this.library_id = OlabPackage.pkgTypeToLibraryID(pkg.package_type);
    this.comps = pkg.comps;
  }

  static infoLog(pkg) {
    OlabUtils.infoLog("pkg.olab_id = " + pkg.olab_id);
    OlabUtils.infoLog("pkg.olab_type = " + pkg.olab_type);
    OlabUtils.infoLog("pkg.name = " + pkg.name);
    OlabUtils.infoLog("pkg.name_uc = " + pkg.name_uc);
    OlabUtils.infoLog("pkg.creator = " + pkg.creator);
    OlabUtils.infoLog("pkg.creator_uc = " + pkg.creator_uc);
    OlabUtils.infoLog("pkg.desc = " + pkg.desc);
    OlabUtils.infoLog("pkg.package_seq_type = " + pkg.package_seq_type);
    OlabUtils.infoLog("pkg.package_type = " + pkg.package_type);
    OlabUtils.infoLog("pkg.library_id = " + pkg.library_id);
    if (pkg.comps !== null) {
      OlabUtils.infoLog("pkg.comps = [");
      pkg.comps.forEach(element => {
        OlabUtils.infoLog(
          "   olab_id = " + element.olab_id + ", qty = " + element.qty
        );
      });
      OlabUtils.infoLog("]");
    }
  }
}

export { OlabPackage };
